import mailSentService from '../../../services/mailSent.service'

export default {
    async getListMailSent({dispatch, commit}, data) {
        return await mailSentService.getListMailSent(data)
            .then(response => {
                if (response.success && response.data) {
                    const listMailSent = response.data.data
                    commit("SET_LIST_MAIL_SENT", listMailSent)
                    return Promise.resolve(response.data);
                } else {
                    commit("SET_LIST_MAIL_SENT", [])
                    dispatch("alertError", response.message, { root: true });
                    return Promise.reject(response.message);
                }
            }).catch(error => {
                commit("SET_LIST_MAIL_SENT", [])
                return Promise.reject(false);
            })
    },
    clearSearchFilter({commit}){
        commit('CLEAR_SERACH_FILTER')
    },
    setMode ({dispatch ,commit}){
        commit('SET_MODE');
    },
}